<template>
  <div class="hello" style="background-color:#f5f5f5f8; height:100%;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <form action="">
          <van-search
            v-model="value"
            show-action
            shape="round"
            background="rgb(53, 120, 229)"
            placeholder="請輸入搜尋關鍵詞"
            @search="onSearch"
            @cancel="onCancel"
          />
      </form>
      </div>
    </van-sticky>
    <div style="max-width: 640px; background: rgb(53, 120, 229); left:auto; margin: 0 auto;height: 130px; border-radius: 0% 0% 50% 50%;"></div>
    <van-cell-group style="border-radius:20px; margin-top:-100px; margin-left:7px; margin-right:7px; min-height: 150px;" :border="false">
      <van-cell style="margin-top:5px; border-radius:20px;" :border="false" size="large" >
        <template>
          <span class="Details-title">搜尋記錄</span>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="border-radius:20px; margin-top:20px; margin-left:7px; margin-right:7px;" :border="false">
      <van-cell style="margin-top:5px; border-radius:20px;" :border="false" size="large" >
        <template>
          <span class="Details-title"><van-icon name="fire-o" />好物推介</span>
        </template>
      </van-cell>
      <van-cell class="recomm-cell" :border="false" size="large">
        <van-grid :column-num="2" clickable :border="false" >
          <van-grid-item v-for="(item,index) in recomm" :key="index" @click="gotoItem(item.ShortLink)">
            <div style="width:100%; height: 10rem;">
              <van-image width="100%" height="100%" :src="item.banner" fit="fill"/>
            </div>
            <div style="height:40px; display:inline">
              <p style="float:left;  font-size:0.5rem;font-weight:900; line-height: 0.6rem; ">{{ item.ItemTitle }}</p>
            </div>
            <div style="width:100%;height:20px;">
              <span style="float:left; font-size:0.7rem; font-weight:900;color: #3578e5;">{{ item.Currency }}${{ item.Price }}起</span>
              <span style="float:right; font-size:0.7rem;color: gray;">售出：{{ item.sales }}</span>
            </div>
          </van-grid-item>
        </van-grid>
      </van-cell>
    </van-cell-group>
  </div>
</template>
<script>
import { getItemRecommend } from '@/api/item'
import { Toast, Notify } from 'vant'

export default {
  name: '',
  data () {
    return {
      recomm: [],
      value: ''
    }
  },
  watch: {
  },
  created () {
    this.getRecommendInfo()
  },
  methods: {
    gotoItem (link) {
      window.scrollTo(0, 0)
      this.$router.push({ path: '/' + link })
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
    },
    goback () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    },
    getRecommendInfo () {
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000
      })
      getItemRecommend({ code: '', nums: 12 }).then(res => {
        if (res.code === 200) {
          this.recomm = []
          this.recomm = res.data
          Toast.clear()
        } else {
          Toast.fail('加載出錯，請刷新重試')
        }
      })
    },
    onSearch () {
      console.log(this.value)
      if (this.value.length <= 0) {
        Notify({ type: 'warning', message: '請先輸入搜尋内容' })
        return false
      }
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
      this.$router.push({path: '/result', query: { name: this.value }})
    },
    onCancel () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-sidebar-item--select::before {
  background-color: rgb(53, 120, 229);
}
.van-tree-select__item--active {
  color: rgb(53, 120, 229);
}
.van-search__action {
  color:#FFFFFF;
}
.recomm-cell{
  border-radius:20px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  }
  .recomm-cell .van-grid >>>.van-grid-item__content {
  padding-top: 2px !important;
  padding-left: 8px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue